import React, { useEffect, useState } from "react";

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import TouchAppIcon from "@mui/icons-material/TouchApp";
import AssessmentIcon from "@mui/icons-material/Assessment";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import PropTypes from "prop-types";
import CircularProgress from "@mui/material/CircularProgress";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useNavigate } from "react-router-dom";
import StudentProfile from "./StudentProfile";
import InternalStaff from "./InternalStaff";
import StaffProfile from "./StaffProfile";
import StaffUpdate from "./StaffUpdate";
import StudentUpdate from "./StudentUpdate";
import StudentSummary from "./StudentSummary";
import StudentAdmissionSummary from "./StudentAdmissionSummary";
import StudentEnrollmentHealth from "./StudentEnrollmentHealth";
//import StudentTransferOrRejoin from "./StudentTransferOrRejoin";
import ServiceTypes from "./ServiceTypes";
import StudentEnrollement from "./StudentEnrollement";
import StudentCertificates from "./StudentCertificates";
import StudentUpdatedCSV from "./StudentUpdatedCSV";
import StaffUpdatedCSV from "./StaffUpdatedCSV";
import UpdateExternalStaffContact from "./UpdateExternalStaffContact";
import AdmittedBatch from "./AdmittedBatch";
import AdmittedBatchBranchMapping from "./AdmittedBatchBranchMapping";
import AdmittedBatchProgramMapping from "./AdmittedBatchProgramMapping";
//import DetailedFeeReport from "./DetailedFeeReport";
import Routes from "./Routes";
import Regulations from "../../client/ERPSetup/Regulations";
import UploadStudent from "../../client/Upload/UploadStudent";
import UploadStaff from "../../client/Upload/UploadStaff";
import ProgramYearSemesterMapping from "./ProgramYearSemesterMapping";
import StudentsPromote from "./StudentsPromote";
import StudentMaster from "./StudentMaster";
import StudentServiceCrud from "./StudentServiceCrud";
import PrintStudyCertificates from "./PrintStudyCertificates";
import TransferCertificate from "./TransferCertificate";
function Office() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [loading, setLoading] = useState(true);
  const [activeView, setActiveView] = useState("home");
  const navigate = useNavigate();
  const [tabValue, setTabValue] = useState(2); // ACTIONS open by default

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  const MenuCard = ({ title, icon, path, color = "#2196F3" }) => (
    <Grid item xs={12} sm={6} md={4} lg={2.4}>
      <MDButton
        fullWidth
        variant="gradient"
        size="large"
        startIcon={icon}
        sx={{
          height: 90,
          fontSize: "0.85rem",
          fontWeight: 700,
          letterSpacing: "0.2px",
          borderRadius: "12px",
          color: "#FFFFFF !important",
          background: `linear-gradient(135deg, ${color} 0%, ${color}CC 100%)`,
          boxShadow: `0 4px 12px ${color}40`,
          transition: "all 0.25s ease",
          "&:hover": {
            background: `linear-gradient(135deg, ${color} 0%, ${color}DD 100%)`,
            transform: "translateY(-4px)",
            boxShadow: `0 8px 20px ${color}60`,
          },
          "& .material-icons-round, & .material-icons": {
            fontSize: "28px",
            color: "#FFFFFF !important",
          },
          "& .MuiSvgIcon-root": {
            fontSize: "28px",
            color: "#FFFFFF",
          },
        }}
        onClick={() => handleNavigate(path)}
      >
        {title}
      </MDButton>
    </Grid>
  );

  MenuCard.propTypes = {
    title: PropTypes.string.isRequired,
    icon: PropTypes.node,
    path: PropTypes.string.isRequired,
    color: PropTypes.string,
  };
  useEffect(() => {
    setLoading(false);
  }, []);

  const getAuthHeaders = () => {
    const token = sessionStorage.getItem("token");
    return {
      Authorization: `Bearer ${token}`,
    };
  };

  const handleNavigate = (path) => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      navigate("/authentication/sign-in");
    } else {
      setActiveView(path);
    }
  };

  const handleBack = () => {
    setActiveView("home");
  };

  const renderContent = () => {
    switch (activeView) {
      case "internalstaff":
        return (
          <>
            <InternalStaff />
          </>
        );
      case "studentprofile":
        return (
          <>
            <StudentProfile />
          </>
        );
      case "studentmaster":
        return (
          <>
            <StudentMaster />
          </>
        );
      case "staffprofile":
        return (
          <>
            <StaffProfile />
          </>
        );

      case "studentadmissionsummary":
        return (
          <>
            <StudentAdmissionSummary />
          </>
        );
      case "studentenrollmenthealth":
        return (
          <>
            <StudentEnrollmentHealth />
          </>
        );

      case "servicetype":
        return (
          <>
            <ServiceTypes />
          </>
        );
      case "studentservicetypes":
        return <StudentServiceCrud kind="types" />;
      case "studentservicenames":
        return <StudentServiceCrud kind="names" />;
      case "studentservicecharges":
        return <StudentServiceCrud kind="charges" />;
      case "studentenrollement":
        return (
          <>
            <StudentEnrollement />
          </>
        );
      case "studentcertificates":
        return (
          <>
            <StudentCertificates />
          </>
        );
      case "studentupdatedcsv":
        return (
          <>
            <StudentUpdatedCSV />
          </>
        );
      case "staffupdate":
        return (
          <>
            <StaffUpdate />
          </>
        );
      case "studentupdate":
        return (
          <>
            <StudentUpdate />
          </>
        );
      case "studentspromote":
        return <StudentsPromote />;
      case "staffupdatedcsv":
        return (
          <>
            <StaffUpdatedCSV />
          </>
        );
      case "updateexternalstaffcontact":
        return (
          <>
            <UpdateExternalStaffContact />
          </>
        );
      case "regulation":
        return (
          <>
            <Regulations />
          </>
        );
      case "admittedbatch":
        return (
          <>
            <AdmittedBatch />
          </>
        );
      case "admittedbatchbranchmapping":
        return (
          <>
            <AdmittedBatchBranchMapping />
          </>
        );
      case "admittedbatchprogrammapping":
        return (
          <>
            <AdmittedBatchProgramMapping />
          </>
        );
      case "programyearsemestermapping":
        return (
          <>
            <ProgramYearSemesterMapping />
          </>
        );
      case "printstudycertificates":
        return <PrintStudyCertificates />;
      case "transfercertificate":
        return <TransferCertificate />;
      case "routes":
        return (
          <>
            <Routes />
          </>
        );
      case "uploadstudent":
        return (
          <>
            <UploadStudent />
          </>
        );
      case "uploadstaff":
        return (
          <>
            <UploadStaff />
          </>
        );
      default:
        return (
          <>
            <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
              <Tabs
                value={tabValue}
                onChange={handleTabChange}
                variant="fullWidth"
                TabIndicatorProps={{
                  sx: {
                    backgroundColor: ["#2196F3", "#4CAF50", "#FF9800", "#9C27B0"][tabValue],
                    height: 5,
                    borderRadius: "4px 4px 0 0",
                  },
                }}
              >
                {[
                  {
                    label: "UPLOADS",
                    icon: <CloudUploadIcon />,
                    color: "#2196F3",
                    bgColor: "rgba(33, 150, 243, 0.10)",
                  },
                  {
                    label: "SETUP",
                    icon: <SettingsSuggestIcon />,
                    color: "#4CAF50",
                    bgColor: "rgba(76, 175, 80, 0.10)",
                  },
                  {
                    label: "ACTIONS",
                    icon: <TouchAppIcon />,
                    color: "#FF9800",
                    bgColor: "rgba(255, 152, 0, 0.12)",
                  },
                  {
                    label: "REPORTS",
                    icon: <AssessmentIcon />,
                    color: "#9C27B0",
                    bgColor: "rgba(156, 39, 176, 0.10)",
                  },
                ].map((item, index) => (
                  <Tab
                    key={item.label}
                    icon={item.icon}
                    iconPosition="top"
                    label={
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          gap: 0.2,
                        }}
                      >
                        <Box
                          component="span"
                          sx={{
                            fontSize: "1rem",
                            fontWeight: 700,
                            letterSpacing: "0.1px",
                            lineHeight: 1.5,
                          }}
                        >
                          {item.label}
                        </Box>

                        {tabValue === index && (
                          <KeyboardArrowDownIcon
                            sx={{
                              fontSize: 30,
                              color: item.color,
                              strokeWidth: 2,
                              filter: "drop-shadow(0 1px 1px rgba(0,0,0,0.25))",
                              mt: 0.2,
                            }}
                          />
                        )}
                      </Box>
                    }
                    sx={{
                      minHeight: 105,
                      py: 1.2,
                      fontWeight: 800,
                      color: `${item.color} !important`,
                      opacity: 1,
                      borderRadius: "10px 10px 0 0",
                      transition: "all 0.25s ease",
                      "& .MuiSvgIcon-root": {
                        fontSize: 34,
                        color: item.color,
                        transition: "transform 0.25s ease",
                      },
                      "&:hover": {
                        backgroundColor: item.bgColor,
                        "& > .MuiTab-iconWrapper": {
                          transform: "scale(1.12)",
                        },
                      },
                      ...(tabValue === index && {
                        backgroundColor: item.bgColor,
                      }),
                    }}
                  />
                ))}
              </Tabs>
            </Box>

            {/* UPLOADS */}
            {tabValue === 0 && (
              <Grid container spacing={2}>
                <MenuCard
                  title="STUDENT UPDATED CSV"
                  icon={<Icon>upload_file</Icon>}
                  path="studentupdatedcsv"
                  color="#2196F3"
                />
                <MenuCard
                  title="STAFF UPDATED CSV"
                  icon={<Icon>upload_file</Icon>}
                  path="staffupdatedcsv"
                  color="#03A9F4"
                />
                <MenuCard
                  title="UPLOAD STUDENTS"
                  icon={<Icon>upload_file</Icon>}
                  path="uploadstudent"
                  color="#00BCD4"
                />
                <MenuCard
                  title="UPLOAD STAFF"
                  icon={<Icon>upload_file</Icon>}
                  path="uploadstaff"
                  color="#1976D2"
                />
              </Grid>
            )}

            {/* SETUP */}
            {tabValue === 1 && (
              <Grid container spacing={2}>
                <MenuCard
                  title="REGULATIONS"
                  icon={<Icon>category</Icon>}
                  path="regulation"
                  color="#4CAF50"
                />
                <MenuCard
                  title="ADMITTED BATCHES"
                  icon={<Icon>school</Icon>}
                  path="admittedbatch"
                  color="#009688"
                />
                <MenuCard
                  title="ADMITTED BATCH PROGRAM MAPPING"
                  icon={<Icon>hub</Icon>}
                  path="admittedbatchprogrammapping"
                  color="#8BC34A"
                />
                <MenuCard
                  title="ADMITTED BATCH BRANCH MAPPING"
                  icon={<Icon>account_tree</Icon>}
                  path="admittedbatchbranchmapping"
                  color="#2E7D32"
                />
                <MenuCard
                  title="PROGRAM YEAR SEMESTER MAPPING"
                  icon={<Icon>account_tree</Icon>}
                  path="programyearsemestermapping"
                  color="#26A69A"
                />
                <MenuCard
                  title="SERVICE TYPES"
                  icon={<Icon>category</Icon>}
                  path="servicetype"
                  color="#66BB6A"
                />
                <MenuCard
                  title="STUDENT SERVICE TYPES"
                  icon={<Icon>category</Icon>}
                  path="studentservicetypes"
                  color="#558B2F"
                />
                <MenuCard
                  title="STUDENT SERVICE NAMES"
                  icon={<Icon>list</Icon>}
                  path="studentservicenames"
                  color="#00A86B"
                />
                <MenuCard
                  title="TRANSPORT ROUTES"
                  icon={<Icon>route</Icon>}
                  path="routes"
                  color="#009688"
                />
              </Grid>
            )}
            {/* ACTIONS */}
            {tabValue === 2 && (
              <Grid container spacing={2}>
                <MenuCard
                  title="INTERNAL STAFF"
                  icon={<Icon>badge</Icon>}
                  path="internalstaff"
                  color="#FF9800"
                />
                <MenuCard
                  title="STUDENT MASTER"
                  icon={<Icon>person</Icon>}
                  path="studentmaster"
                  color="#FF9800"
                />
                <MenuCard
                  title="STUDENT PROFILE"
                  icon={<Icon>person</Icon>}
                  path="studentprofile"
                  color="#de5930"
                />
                <MenuCard
                  title="PROMOTE STUDENTS"
                  icon={<Icon>badge</Icon>}
                  path="studentspromote"
                  color="#FB8C00"
                />
                <MenuCard
                  title="STAFF PROFILE"
                  icon={<Icon>manage_accounts</Icon>}
                  path="staffprofile"
                  color="#E65100"
                />
                <MenuCard
                  title="UPDATE STAFF DETAILS"
                  icon={<Icon>contact_phone</Icon>}
                  path="staffupdate"
                  color="#FF7043"
                />
                <MenuCard
                  title="UPDATE STUDENT DETAILS"
                  icon={<Icon>contact_phone</Icon>}
                  path="studentupdate"
                  color="#F57C00"
                />
                <MenuCard
                  title="STUDENT ENROLLEMENT"
                  icon={<Icon>how_to_reg</Icon>}
                  path="studentenrollement"
                  color="#EF6C00"
                />
                <MenuCard
                  title="STUDENT CERTIFICATES"
                  icon={<Icon>workspace_premium</Icon>}
                  path="studentcertificates"
                  color="#D84315"
                />
              </Grid>
            )}

            {/* REPORTS */}
            {tabValue === 3 && (
              <Grid container spacing={2}>
                <MenuCard
                  title="STUDENT ADMISSION SUMMARY"
                  icon={<Icon>summarize</Icon>}
                  path="studentadmissionsummary"
                  color="#9C27B0"
                />
                <MenuCard
                  title="STUDENT ENROLLMENT HISTORY"
                  icon={<Icon>monitor_heart</Icon>}
                  path="studentenrollmenthealth"
                  color="#673AB7"
                />
                <MenuCard
                  title="PRINT STUDY CERTIFICATES"
                  icon={<Icon>workspace_premium</Icon>}
                  path="printstudycertificates"
                  color="#5C6BC0"
                />
                <MenuCard
                  title="PRINT TRANSFER CERTIFICATES"
                  icon={<Icon>workspace_premium</Icon>}
                  path="transfercertificate"
                  color="#AD1457"
                />
              </Grid>
            )}
          </>
        );
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={2} pb={3}>
        {loading ? (
          <MDBox display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
            <CircularProgress color="info" />
          </MDBox>
        ) : (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Card>
                {/* HEADER - Matching Library Management System card design */}
                <MDBox
                  mx={2}
                  mt={-1}
                  py={1}
                  px={2}
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  flexWrap="wrap"
                  gap={1}
                >
                  <MDBox display="flex" alignItems="center" gap={1}>
                    <Icon sx={{ color: "#FFFFFF" }}>manage_accounts</Icon>

                    <MDTypography variant="h6" color="white">
                      OFFICE
                    </MDTypography>
                  </MDBox>

                  {activeView !== "home" ? (
                    <MDButton
                      variant="contained"
                      onClick={handleBack}
                      startIcon={<Icon>arrow_back</Icon>}
                      sx={{
                        mb: 0,
                        color: "#FFFFFF",
                        backgroundColor: "rgba(255,255,255,0.18)",
                        "&:hover": {
                          backgroundColor: "rgba(255,255,255,0.28)",
                        },
                      }}
                    >
                      Back to Office
                    </MDButton>
                  ) : (
                    <MDButton
                      variant="contained"
                      onClick={() => navigate("/dashboard")}
                      startIcon={<Icon>dashboard</Icon>}
                      sx={{
                        mb: 0,
                        color: "#FFFFFF !important",
                        backgroundColor: "rgba(255,255,255,0.18) !important",
                        boxShadow: "none !important",
                        "& .material-icons": {
                          color: "#FFFFFF !important",
                        },
                        "&:hover": {
                          color: "#FFFFFF !important",
                          backgroundColor: "rgba(255,255,255,0.28) !important",
                          boxShadow: "none !important",
                        },
                        "&:focus": {
                          color: "#FFFFFF !important",
                          backgroundColor: "rgba(255,255,255,0.18) !important",
                        },
                        "&:active": {
                          backgroundColor: "rgba(255,255,255,0.28) !important",
                        },
                      }}
                    >
                      Dashboard
                    </MDButton>
                  )}
                </MDBox>

                {/* CONTENT */}
                <MDBox p={1}>{renderContent()}</MDBox>
              </Card>
            </Grid>
          </Grid>
        )}
      </MDBox>
      <MDBox display="flex" flexDirection="column" minHeight="50vh">
        {/* This empty div is intentional for layout spacing */}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Office;
